/**
 * Helpers de formatação de data pra PDF/UI cliente-facing.
 *
 * Introduzido pela hotfix TD48/TD53 (post-Sprint5A).
 *
 * Usa timeZone explícito 'America/Sao_Paulo' para evitar shift de timezone
 * (TD22): se o backend retorna ISO em UTC e o browser interpreta no fuso
 * local, datas próximas da meia-noite podem aparecer "no dia errado". Forçar
 * fuso garante consistência independente de onde o usuário está.
 */

const TIMEZONE = 'America/Sao_Paulo';

/**
 * Formata um valor de data (string ISO, Date, etc.) como "DD/MM/YYYY" pt-BR.
 * Retorna '—' pra null/undefined/empty/invalid input — placeholder seguro
 * pra render em template (jamais quebra com NaN ou "Invalid Date").
 */
export function formatDataPtBR(value) {
  if (!value) return '—';
  try {
    const d = new Date(value);
    if (isNaN(d.getTime())) return '—';
    return d.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      timeZone: TIMEZONE,
    });
  } catch {
    return '—';
  }
}
